export const BannerParamKeyValues = {
    FREE_UNITS: 'free_units',
    DISCOUNT: 'discount',
} as const;

export type BannerParamKeyValue =
    typeof BannerParamKeyValues[keyof typeof BannerParamKeyValues];

export class BannerParamKey {

    constructor(private _value: string) {
        if (!this.VALID_KEYS.includes(_value as BannerParamKeyValue)) {
            throw new Error(`Invalid BannerParamKey value: ${_value}. Valid values are: ${this.VALID_KEYS.join(', ')}`);
        }
    }

    private readonly VALID_KEYS: string[] = Object.values(BannerParamKeyValues);

    get value(): BannerParamKeyValue {
        return this._value as BannerParamKeyValue;
    }

}
